<div class="bg-cloud min-vh-100">
    <app-default-header></app-default-header>
    <router-outlet></router-outlet>
</div>

